export default {
  common: {
    create: 'Create',
    connectWallet: 'Connect Wallet',
    language: {
      en: 'English',
      zh: 'Chinese'
    },
    loading: 'Loading...',
    success: 'Success',
    failed: 'Failed',
    confirm: 'Confirm',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    search: 'Search',
    noData: 'No Data',
    retry: 'Retry',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    hours: 'Hours'
  },
  sidebar: {
    home: 'Home',
    board: 'Board',
    createCoin: 'Create Coin',
    myWallet: 'My Wallet',
    more: 'More',
    menu: {
      howItWorks: 'How it works',
      support: 'Support'
    },
    footer: {
      email: 'Email: contact@yolopad.fun',
      copyright: '© 2025 YOLOPad. All rights reserved.'
    }
  },
  game: {
    title: 'YOLO Game',
    description: 'Join the YOLO game and win big!',
    status: {
      active: 'Active',
      ended: 'Ended',
      upcoming: 'Upcoming'
    },
    round: {
      current: 'Current Round',
      total: 'Total Rounds',
      participants: 'Participants',
      deposit: 'Total Deposit',
      burned: 'Total Burned',
      reward: 'Reward Pool'
    },
    actions: {
      mint: 'Mint',
      burn: 'Burn',
      claim: 'Claim',
      deposit: 'Deposit',
      withdraw: 'Withdraw'
    },
    messages: {
      mintSuccess: 'Mint successful!',
      burnSuccess: 'Burn successful!',
      claimSuccess: 'Claim successful!',
      depositSuccess: 'Deposit successful!',
      withdrawSuccess: 'Withdraw successful!',
      roundEnded: 'This round has ended',
      roundNotStarted: 'This round has not started yet',
      insufficientBalance: 'Insufficient balance for this operation',
      maxParticipantsReached: 'Maximum number of participants reached',
      minCapNotReached: 'Minimum cap not reached',
      maxRoundReached: 'Maximum round reached'
    },
    tokenInfo: {
      createAt: 'Created At',
      totalSupply: 'Total Supply',
      totalBurned: 'Total Burned',
      mintPrice: 'Mint Price',
      trade: 'Trade',
      copy: 'Copy',
      token: 'Token',
      game: 'Game',
      createBy: 'Created By'
    },
    roundInfo: {
      title: 'Round Information',
      status: {
        ended: 'Ended',
        notStarted: 'Not Started',
        launchFailed: 'Launch Failed',
        minting: 'Minting',
        waiting: 'Waiting',
        burning: 'Burning',
        claiming: 'Claiming'
      },
      stats: {
        round: 'Round',
        totalMinter: 'Total Minter',
        totalBurner: 'Total Burner',
        minted: 'Minted',
        burned: 'Burned'
      },
      progress: {
        minCap: 'Min Cap Progress',
        timeRemaining: 'Time Remaining'
      },
      refund: 'Refund'
    },
    rewards: {
      title: 'Reward Rankings',
      rewardPool: 'Reward Pool',
      rank: 'Rank',
      address: 'Address',
      burnedAmount: 'Burned Amount',
      reward: 'Reward'
    },
    gameInfo: {
      title: 'Game Information',
      totalRounds: 'Total Rounds',
      minCap: 'Min Cap',
      mintingTime: 'Minting Time',
      burningTime: 'Burning Time',
      rollRate: 'Roll Rate'
    },
    operation: {
      mint: {
        title: 'Enter Mint Amount',
        button: 'Mint',
        totalMinted: 'Game Total Minted'
      },
      burn: {
        title: 'Enter Burn Amount',
        button: 'Burn',
        holdingAmount: 'Holding Amount'
      }
    },
    roundHistory: {
      title: 'Round History',
      status: {
        active: 'Active',
        completed: 'Completed',
        upcoming: 'Upcoming'
      },
      details: {
        round: 'Round',
        view: 'View Details',
        hide: 'Hide Details',
        minter: 'Minter',
        minted: 'Minted',
        burner: 'Burner',
        burned: 'Burned',
        rewardPool: 'Reward Pool',
        yourData: 'Your Data',
        mintedAmount: 'Minted Amount',
        burnedAmount: 'Burned Amount',
        rank: 'Rank',
        claimableReward: 'Claimable Reward',
        claimStatus: 'Claim Status',
        claimed: 'Claimed',
        claim: 'Claim',
        noWinners: 'No Winners date',
        loadingWinners: 'Loading winners data...'
      }
    },
    errors: {
      connectWallet: 'Please connect your wallet',
      networkError: 'Network Error',
      contractNotDeployed: 'Contract not deployed on current network'
    }
  },
  create: {
    basicSetting: 'Basic Setting',
    advancedSetting: 'Advanced Setting',
    name: 'Name',
    ticker: 'Ticker',
    description: 'Description(Max 180)',
    imageOrVideo: 'Image or video',
    selectFile: 'Select file',
    selectFileTip: 'Select an image or video(Max 10MB)',
    minCap: 'MinCap(Min 0.01{{token}})',
    minCapTip: 'MinCap is the minimum amount that can be raised in the first round. If it is not reached, the launch fails and a refund is available',
    maxRound: 'Max Round',
    maxRoundTip: 'Max Round is the maximum number of rounds that can be created',
    roundDuration: 'Round Duration(By Hour)',
    roundDurationTip: 'Round duration refers to the duration of mint and burn in each round, which cannot be less than 0.1 hour',
    rolloverRate: 'Rollover Rate(10~100)',
    rolloverRateTip: 'The funds in the game reward pool will be distributed to the next round according to the rollover rate (percentage)',
    rewardRanks: 'Reward Ranks',
    rewardRanksTip: 'Set the distribution ratio of the reward ranking list. The total value + Rollover Rate cannot be greater than 100',
    telegramLink: 'Telegram link',
    websiteLink: 'Website link',
    twitterLink: 'Twitter or X link',
    showMore: 'Show more options ↓',
    hideMore: 'Hide more options ↑',
    createCoin: 'Create Coin',
    createTip: 'Tip: coin data cannot be changed after creation',
    placeholder: {
      minCap: 'E.g.10',
      maxRound: 'E.g.10',
      roundDuration: 'E.g.1',
      rolloverRate: 'Min 10',
      rank: 'Rank {{index}}',
      optional: '(optional)'
    }
  },
  validation: {
    minCap: {
      required: 'MinCap is required',
      invalidFormat: 'Please enter a valid number with up to 2 decimal places'
    },
    maxRound: {
      required: 'Max Round is required',
      invalidFormat: 'Please enter a valid integer'
    },
    roundDuration: {
      required: 'Round Duration is required',
      invalidFormat: 'Please enter a valid number with up to 2 decimal places',
      tooSmall: 'Value must be at least 0.1'
    },
    rolloverRate: {
      required: 'Rollover Rate is required',
      invalidRange: 'Please enter a number between 10 and 100'
    },
    name: {
      required: 'Name is required',
      tooLong: 'Name cannot exceed 50 characters'
    },
    ticker: {
      required: 'Ticker is required',
      tooLong: 'Ticker cannot exceed 10 characters',
      invalidFormat: 'Ticker can only contain letters and numbers'
    },
    description: {
      required: 'Description is required',
      tooLong: 'Description cannot exceed 180 characters'
    },
    links: {
      invalidTelegram: 'Please enter a valid Telegram link (https://t.me/...)',
      invalidTwitter: 'Please enter a valid Twitter/X link',
      invalidWebsite: 'Please enter a valid website URL'
    },
    file: {
      required: 'File is required',
      tooLarge: 'File size must be less than 10MB',
      invalidType: 'Invalid file type',
      uploadFailed: 'Upload failed, please try again'
    },
    reward: {
      invalidRange: 'Please enter a number between 0 and 100',
      totalExceeded: 'Total reward ({{total}}%) cannot exceed 100%. Please adjust your values.'
    }
  },
  errors: {
    networkError: 'Network Error',
    insufficientBalance: 'Insufficient Balance',
    transactionFailed: 'Transaction Failed',
    connectWallet: 'Please connect your wallet and select a network',
    contractNotDeployed: 'Contract not deployed on current network',
    gameCreationFailed: 'Failed to create game',
    transactionRejected: 'Transaction was rejected by user',
    insufficientFunds: 'Insufficient funds to complete the transaction',
    walletConnectionFailed: 'Failed to connect wallet',
    networkSwitchFailed: 'Failed to switch network',
    contractCallFailed: 'Contract call failed',
    gasEstimationFailed: 'Failed to estimate gas',
    unknownError: 'An unknown error occurred'
  },
  toast: {
    success: {
      title: 'Success',
      message: 'Operation completed successfully'
    },
    error: {
      title: 'Error',
      message: 'Operation failed'
    },
    warning: {
      title: 'Warning',
      message: 'Please check your input'
    },
    info: {
      title: 'Info',
      message: 'Please note'
    }
  },
  mywallet: {
    walletAddress: 'Wallet Address:',
    invitedRewards: 'Invited Rewards:',
    inviter: 'Inviter:',
    bindInviter: 'Bind Inviter',
    inviteLinkPrefix: 'Click to copy the invitation link:',
    shareMessage: 'Share your invitation link to earn rewards',
    shareToX: 'Share to X',
    tabs: {
      invitationList: 'Invitation List',
      myCreate: 'My Create',
      myFavorite: 'My Favorite'
    },
    noData: 'No data yet',
    modal: {
      enterInviteCode: 'Enter invite code',
      invalidCode: 'Invalid invite code, please check and try again',
      bindFailed: 'Failed to bind inviter, please check the invite code or try again'
    },
    toast: {
      inviteLinkCopied: 'Invite link copied to clipboard!'
    }
  },
  modal: {
    bindInviter: 'Bind Inviter',
    cancel: 'Cancel',
    confirm: 'Confirm'
  },
  home: {
    title: 'YOU ONLY LAUNCH ONCE',
    subtitle: 'Create, mint, burn, and win — YOLOPad is where tokens are born and battles begin',
    joinButton: 'JOIN THE BATTLE',
    features: {
      launch: {
        title: 'Launch Your Own Token',
        description: 'Be the next meme overlord. Deploy a token + rules + chaos, in 1 minute.'
      },
      mint: {
        title: 'Mint to Join',
        description: 'Get in early. Fixed price, limited time. The earlier you mint, the cheaper you win.'
      },
      burn: {
        title: 'Burn to Win',
        description: 'Burn tokens for leaderboard glory. Top burners split the BNB rewards.'
      },
      invite: {
        title: 'Invite to Earn',
        description: 'On-chain referrals. 1% real-time BNB rewards from your frend\'s mints. Forever.'
      },
      arb: {
        title: 'Arb Like a Degen',
        description: 'Mint here, trade there. Price gaps = profit, if you\'re fast enough.'
      },
      lottery: {
        title: 'BNB Lottery Pools',
        description: 'Every 10 BNB triggers a jackpot. If you minted, you might just hit it.'
      }
    },
    footer: '⚡ Some early users may end up on a list. We won\'t say what kind.'
  },
  gameList: {
    address: 'Address:',
    creator: 'Creator:',
    minCap: 'MinCap:',
    loading: 'Loading...',
    loadMore: 'Load More',
    errors: {
      connectWallet: 'Please connect your wallet and select a network',
      networkError: 'Failed to fetch data. Please check your network connection or switch network.',
      contractNotDeployed: 'Contract not deployed on current network'
    },
    progress: {
      failed: 'Failed',
      percent: '{{percent}}%'
    }
  },
  luckdraw: {
    lotteryStatus: 'Lottery Status',
    loading: 'Loading...',
    completed: 'Completed',
    started: 'Ongoing',
    notStarted: 'Not Started',
    participants: 'Participants',
    noParticipants: 'No participants yet',
    winners: 'Winners',
    noWinners: 'No winners yet',
    notDrawn: 'Not drawn yet',
    yourStatus: 'Your Lottery Status',
    notConnected: 'Please connect your wallet',
    isParticipant: 'You have participated in the lottery',
    notParticipant: 'You have not participated in the lottery',
    isWinner: 'Congratulations, you are a winner!',
    notWinner: 'Sorry, you did not win'
  }
}; 